import React from 'react'
import { Form, Label, Input } from "reactstrap";
import { formatDate } from "../../../../Utils/format-date.js";
import './EditGoal.css'

const EditGoal = (props) => {
    return (
        <div className='edit-goal-modal'>
            <Form>
                <Label>ASSESSMENT DATE</Label>
                <Input readOnly
                    value={formatDate(props.date)}
                />
                <Label>ORIENTATION</Label>
                <Input defaultValue={props.orientation} type='select'>
                    <option>Relationship</option>
                    <option>Nurturing</option>
                    <option>Leadership</option>
                    <option>Achievement</option>
                    <option>Learning</option>
                </Input>
                <Label>MY WORKSHEET NAME</Label>
                <Input placeholder={props.name} />
                <div className='buttons'>
                    <input type='reset' value='RESET' className='reset-button' />
                    <button onClick={props.handleModalClose} className='update-button'>UPDATE</button>
                </div>
            </Form>
        </div>
    )
}

export default EditGoal



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Goal-Setting-Worksheets/Edit-Goal/EditGoal.jsx